export default __webpack_public_path__ + "static/media/slide-cell-3.c6621e91.svg";